import { render, staticRenderFns } from "./WebPartHRDesigner.vue?vue&type=template&id=2c58936a&scoped=true&"
import script from "./WebPartHRDesigner.vue?vue&type=script&lang=js&"
export * from "./WebPartHRDesigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c58936a",
  null
  
)

export default component.exports